"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debounceEvent(msDelay, eventDef) {
    var timeout;
    return function debouncedEventDef(action, prevState, nextState) {
        if (timeout) {
            clearTimeout(timeout);
        }
        return new Promise(function (resolve) {
            timeout = setTimeout(function () {
                resolve(eventDef(action, prevState, nextState));
            }, msDelay);
        });
    };
}
exports.default = debounceEvent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@redux-beacon/debounce-event/dist/debounce-event.js
// module id = 822
// module chunks = 16